import { render, staticRenderFns } from "./revenueByChannel.vue?vue&type=template&id=461830f4&scoped=true"
import script from "./revenueByChannel.vue?vue&type=script&lang=js"
export * from "./revenueByChannel.vue?vue&type=script&lang=js"
import style0 from "./revenueByChannel.vue?vue&type=style&index=0&id=461830f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461830f4",
  null
  
)

export default component.exports